import styled from 'styled-components';

export interface IButtonProps {
    onClick?: (filterEventsItemId: number) => void;
}

export const LowerWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 55px;
    z-index: 1;
    width: 200px;
    background: #fff;
    box-shadow: 0 3px 15px -2px #bbb;
    border: 1px solid #ddd;
`;

export const FilterEventsItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const FilterEventsItem = styled.button<IButtonProps>`
    display: flex;
    font-size: 0.9rem;
    color: #04265a;
    background: #fff;
    border: 1px solid #ccc;
    cursor: pointer;
    padding: 3px 10px;
    margin: 0 6px 0 0;
`;
